export default "__VITE_ASSET__kpdR2Nmh__"